import React from "react";
import { homeContent } from "../data/redlandGolfContent";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import {
  Breadcrumbs,
  FeatureGrid,
  PageHero,
  SectionHeading,
  TextBlock,
} from "../components/RedlandComponents";

export default function AboutUs() {
  const { about } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="About Us" />
      <PageHero
        eyebrow="A South Florida Tradition"
        title={about.title}
        copy="A welcoming South Florida golf course with leagues, junior golf, restaurant hospitality, and tournament tradition."
        image={about.heroImage}
        badge="Serving South Florida Since 1947"
        tags={[
          "Opened in 1947",
          "18-Hole Golf Course",
          "Home of the Homestead Amateur Golf Classic",
        ]}
        metaTitle="Redland at a Glance"
        metaItems={["Full-service Pro Shop", "Banquet facility", "Ladies' and Men's Leagues"]}
        actions={
          <ButtonLink href="/rates" variant="secondary">
            View Rates
          </ButtonLink>
        }
      />
      <section className="section">
        <div className="container narrow">
          <TextBlock text={about.body} />
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Club Features" />
          <FeatureGrid items={about.features} />
        </div>
      </section>
      <section className="section">
        <div className="container split-section junior-feature">
          <div>
            <SectionHeading title="Junior Golf" copy={homeContent.juniorPreview.copy} />
            <ButtonLink href="/junior-golf" variant="secondary">
              Learn More
            </ButtonLink>
          </div>
          <FeatureGrid items={["Redland Junior Golf", "Education programs", "Healthy choices"]} />
        </div>
      </section>
    </>
  );
}
